"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenAction = exports.EventType = exports.TAG = exports.TYPES = void 0;
exports.TYPES = {
    V4ReportService: Symbol.for("@al/event-tracking/v4/V4ReportService"),
    ILogService: Symbol.for("@al/event-tracking/v4/ILogService"),
    NativePreProcessor: Symbol.for("@al/event-tracking/v4/NativePreProcessor"),
    WebPreProcessor: Symbol.for("@al/event-tracking/v4/WebPreProcessor"),
    ILogDataStore: Symbol.for("@al/event-tracking/v4/ILogDataStore"),
    SaveDataTask: Symbol.for("@al/event-tracking/v4/SaveDataTask"),
    IUploadTimerService: Symbol.for("@al/event-tracking/v4/IUploadTimerService"),
    QueryDataTask: Symbol.for("@al/event-tracking/v4/QueryDataTask"),
    CleanUploadData: Symbol.for("@al/event-tracking/v4/CleanUploadData"),
    UploadTask: Symbol.for("@al/event-tracking/v4/UploadTask"),
    AfterUploadTask: Symbol.for("@al/event-tracking/v4/AfterUploadTask"),
    IDispatchLogsService: Symbol.for("@al/event-tracking/v4/IDispatchLogsService"),
    IClickService: Symbol.for("@al/event-tracking/v4/IClickService"),
    IInputService: Symbol.for("@al/event-tracking/v4/IInputService"),
    IExposeService: Symbol.for("@al/event-tracking/v4/IExposeService"),
    IStatisticsService: Symbol.for("@al/event-tracking/v4/IStatisticsService"),
    ILeaveOpsService: Symbol.for("@al/event-tracking/v4/ILeaveOpsService"),
    IRemoveLogsService: Symbol.for("@al/event-tracking/v4/IRemoveLogsService"),
    IExposeDataManager: Symbol.for("@al/event-tracking/v4/IExposeDataManager"),
    IPrintLogService: Symbol.for("@al/event-tracking/v4/IPrintLogService"),
};
exports.TAG = {
    V4ReportService: Symbol.for("@al/event-tracking/v4/tag/V4ReportService"),
    NativeGateway: Symbol.for("@al/event-tracking/v4/tag/NativeGateway"),
    WebGateway: Symbol.for("@al/event-tracking/v4/tag/WebGateway"),
    WebLogService: Symbol.for("@al/event-tracking/v4/tag/WebLogService"),
    NativeLogService: Symbol.for("@al/event-tracking/v4/tag/NativeLogService"),
    ClickEventObserver: Symbol.for("@al/event-tracking/v4/tag/ClickEventObserver"),
    InputEventObserver: Symbol.for("@al/event-tracking/v4/tag/InputEventObserver"),
    UnloadEventObserver: Symbol.for("@al/event-tracking/v4/tag/UnloadEventObserver"),
    VisibilityEventObserver: Symbol.for("@al/event-tracking/v4/tag/VisibilityEventObserver"),
    SDKConfigService: Symbol.for("@al/event-tracking/v4/tag/SDKConfigService"),
    NativeUploadLogsService: Symbol.for("@al/event-tracking/v4/tag/NativeUploadLogsService"),
    WebClickService: Symbol.for("@al/event-tracking/v4/tag/WebClickService"),
    NativeClickService: Symbol.for("@al/event-tracking/v4/tag/NativeClickService"),
    WebInputService: Symbol.for("@al/event-tracking/v4/tag/WebInputService"),
    NativeInputService: Symbol.for("@al/event-tracking/v4/tag/NativeInputService"),
    BeforeSaveTask: Symbol.for("@al/event-tracking/v4/tag/BeforeSaveTask"),
    TimeProcessorTask: Symbol.for("@al/event-tracking/v4/tag/TimeProcessorTask"),
    SaveLogsTask: Symbol.for("@al/event-tracking/v4/tag/SaveLogsTask"),
    WebCleanUploadLogs: Symbol.for("@al/event-tracking/v4/tag/WebCleanUploadLogs"),
    NativeCleanUploadLogs: Symbol.for("@al/event-tracking/v4/tag/NativeCleanUploadLogs"),
    WebUploadTask: Symbol.for("@al/event-tracking/v4/tag/WebUploadTask"),
    NativeUploadTask: Symbol.for("@al/event-tracking/v4/tag/NativeUploadTask"),
    AfterUploadTask: Symbol.for("@al/event-tracking/v4/tag/AfterUploadTask"),
    QueryLogsTask: Symbol.for("@al/event-tracking/v4/tag/QueryLogsTask"),
    MarkLogsUploadable: Symbol.for("@al/event-tracking/v4/tag/MarkLogsUploadable"),
    SaveLogsService: Symbol.for("@al/event-tracking/v4/tag/SaveLogsService"),
    NativeUploadSavedService: Symbol.for("@al/event-tracking/v4/NativeUploadSavedService"),
    LocalStoreService: Symbol.for("@al/event-tracking/v4/LocalStoreService"),
    SessionStoreService: Symbol.for("@al/event-tracking/v4/SessionStoreService"),
    EventOrderBucket: Symbol.for("@al/event-tracking/v4/tag/EventOrderBucket"),
    ExposeEventObserver: Symbol.for("@al/event-tracking/v4/tag/ExposeEventObserver"),
};
var EventType;
(function (EventType) {
    EventType[EventType["Statistics"] = 0] = "Statistics";
    EventType[EventType["View"] = 3] = "View";
    EventType[EventType["Click"] = 4] = "Click";
    EventType[EventType["Expose"] = 5] = "Expose";
    EventType[EventType["Input"] = 6] = "Input";
})(EventType = exports.EventType || (exports.EventType = {}));
var ScreenAction;
(function (ScreenAction) {
    ScreenAction[ScreenAction["Enter"] = 0] = "Enter";
    ScreenAction[ScreenAction["Leave"] = 1] = "Leave";
})(ScreenAction = exports.ScreenAction || (exports.ScreenAction = {}));
